import { render, staticRenderFns } from "./default.vue?vue&type=template&id=1a9a34fc&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=1a9a34fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a34fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Robot: require('/builds/master/frontend/frontend-universe/components/robot.vue').default})
